<app-matrix-card
  title="Feature Comparison"
  iconUrl="/icons/flashlight_yellow.png"
  link="/feature-comparison"
  iconPosition="bottom-center"
  aria-label="Feature Comparison"
>
</app-matrix-card>


